import '@web/shared-digital-library/icons/svg-originals/plus.svg';
import '@web/shared-digital-library/icons/svg-originals/minus.svg';
import '@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
var MdmLink = () => import('~/components/atoms/MdmLink.vue');
export default {
  name: 'Accordion',
  components: {
    MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    productLine: {
      type: String,
      required: false,
      default: ''
    },
    subtitle: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: ''
    },
    withChevronIcon: {
      type: Boolean,
      default: false
    },
    forceToggleFold: {
      type: Boolean,
      default: false
    },
    externalFold: {
      type: Boolean,
      default: false
    },
    titleCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFolded: !this.foldValue
    };
  },
  computed: {
    toggleCondition() {
      return !this.isFolded || this.externalFold;
    }
  },
  methods: {
    toggleFold() {
      if (!this.forceToggleFold) {
        this.isFolded = !this.isFolded;
      }
    }
  }
};